import ShareButton from './ShareButton';
import ShareButtonContainer from './ShareButton.container';
export default ShareButtonContainer(ShareButton);
//# sourceMappingURL=index.js.map